// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const FIREBASE_CONFIG = {
  apiKey: "AIzaSyCRwol0_MfWTw6YfJZoXc2dk5J7wIsmrJ8",
  authDomain: "mustangs-fc.firebaseapp.com",
  databaseURL: "https://mustangs-fc-default-rtdb.firebaseio.com",
  projectId: "mustangs-fc",
  storageBucket: "mustangs-fc.appspot.com",
  messagingSenderId: "1065546259514",
  appId: "1:1065546259514:web:23fe06c3a54fbaba90a903",
  measurementId: "G-MBLL7S3473",
};
